import { render, staticRenderFns } from "./InventoyMinimumAndMaximum.vue?vue&type=template&id=6de08512&scoped=true"
import script from "./InventoyMinimumAndMaximum.vue?vue&type=script&lang=js"
export * from "./InventoyMinimumAndMaximum.vue?vue&type=script&lang=js"
import style0 from "./InventoyMinimumAndMaximum.vue?vue&type=style&index=0&id=6de08512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de08512",
  null
  
)

export default component.exports